import { navigate } from 'widgets-for-react'

export const fullyQualifyUrl = (path: string) => `${window.location.protocol}//${window.location.host}${path}`

/**
 * Navigates to `path`, appending a query string built from `params`.
 * Entries with an empty/undefined value are omitted. Callers are responsible
 * for any value normalization (trimming, lowercasing) they need.
 *
 * Use this from event handlers, never during render: `navigate` pushes to the
 * browser history, and calling it while rendering can clobber other pending
 * navigations.
 */
export const navigateWithParams = (path: string, params: Record<string, string | undefined>): void => {
  const query = new URLSearchParams()
  Object.keys(params).forEach((key) => {
    const value = params[key]
    if (value) query.append(key, value)
  })
  const queryString = query.toString()
  navigate(queryString ? `${path}?${queryString}` : path)
}
